import {
  getLeagueLeadersApiV1NbaLeadersGet,
  getLeagueLeadersApiV1WnbaLeadersGet,
  getStandingsApiV1NbaStandingsGet,
  getStandingsApiV1WnbaStandingsGet,
  getNbaScheduleGamesApiV1NbaGamesScheduleGet,
  getWnbaScheduleGamesApiV1WnbaGamesScheduleGet,
  getNbaLiveGamesApiV1NbaGamesLiveGet,
  getWnbaLiveGamesApiV1WnbaGamesLiveGet,
  LeagueLeader,
  Season,
  Stat,
  TeamStanding,
  ScheduleGame,
  LiveGameScore,
} from "../client";
import { LEAGUE } from "../models/NBA";

export const getLeagueLeaders = async (league: LEAGUE, stats: Stat[], season: Season, signal?: AbortSignal): Promise<{ [key: string]: LeagueLeader[] }> => {
  try {
    const options = { query: { stats, season }, signal }
    const result = league === LEAGUE.NBA
      ? await getLeagueLeadersApiV1NbaLeadersGet(options)
      : await getLeagueLeadersApiV1WnbaLeadersGet(options)

    if (!result.response.ok) throw new Error("No league leaders found")
    return result.data || {}

  } catch (error) {
    if ((error as Error)?.name === "AbortError" || signal?.aborted) {
      throw error
    }
    throw error
  }
}

export const getStandings = async (league: LEAGUE, season?: Season, signal?: AbortSignal): Promise<TeamStanding[]> => {
  try {
    const options = { ...(season ? { query: { season } } : {}), signal }
    const result = league === LEAGUE.NBA
      ? await getStandingsApiV1NbaStandingsGet(options)
      : await getStandingsApiV1WnbaStandingsGet(options)

    if (!result.response.ok) throw new Error("Unable to get standings")
    return result.data || []
  } catch (error) {
    if ((error as Error)?.name === "AbortError" || signal?.aborted) {
      throw error
    }
    throw error
  }
}

export const getScheduleGames = async (
  league: LEAGUE,
  days: number = 5,
  limit: number = 25,
  signal?: AbortSignal
): Promise<ScheduleGame[]> => {
  try {
    const options = { query: { days, limit }, signal }
    const result = league === LEAGUE.NBA
      ? await getNbaScheduleGamesApiV1NbaGamesScheduleGet(options)
      : await getWnbaScheduleGamesApiV1WnbaGamesScheduleGet(options)

    if (!result.response.ok) throw new Error("Unable to get schedule games")
    return result.data || []
  } catch (error) {
    if ((error as Error)?.name === "AbortError" || signal?.aborted) {
      throw error
    }
    throw error
  }
}

export const getLiveScores = async (
  league: LEAGUE,
  signal?: AbortSignal
): Promise<LiveGameScore[]> => {
  try {
    const options = { signal }
    const result = league === LEAGUE.NBA
      ? await getNbaLiveGamesApiV1NbaGamesLiveGet(options)
      : await getWnbaLiveGamesApiV1WnbaGamesLiveGet(options)

    if (!result.response.ok) throw new Error("Unable to get live scores")
    return result.data || []
  } catch (error) {
    if ((error as Error)?.name === "AbortError" || signal?.aborted) {
      throw error
    }
    throw error
  }
}